/**
 * INT-1602: analytics for the undelivered-message mark, on the front.
 *
 * The mark's own transitions (`lead.undelivered.mark_applied` /
 * `mark_cleared`) are emitted server-side by leads-service; these two are the
 * gestures only the web app sees. Names follow `front.<domain>.<entity>.<action>`.
 */
export const UNDELIVERED_EVENTS = {
  /**
   * A person turned on a "No entregados" filter. Carries where (`surface`),
   * which control (`level`) and how many leads it lists (`result_count`, the
   * count already loaded for that control).
   */
  FILTER_USED: 'front.chat.undelivered.filter_used',

  /**
   * A person opened "Cómo resolverlo" on a failed message's error notice.
   * Carries the error code and the UI language, which surfaces copy gaps
   * (pt-BR, INT-1600) in production without waiting for a ticket.
   */
  NOTICE_OPENED: 'front.chat.undelivered.notice_opened',
} as const;

/** Which control turned the filter on. `badge_etapa` waits for INT-1598. */
export type tUndeliveredFilterLevel =
  | 'chip_chats'
  | 'chip_embudo'
  | 'panel_embudo';
